// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getClaimsInProgress} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const readClaims = status =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getClaimsInProgress(status);

            dispatch({
                data,
                type: actions.UPDATE_CLAIMS_IN_PROGRESS_DATA
            });

            if (!getState().exportToExcel.selectedExcelLayout.claims.name) {

                readExcelLayouts('claims')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/action-creators/read-claims.js